export default "__VITE_ASSET__Bsnyiu6d__"